import * as React from 'react';
// import * as ReactDom from 'react-dom';
import * as d3 from 'd3';
import { PVABadge } from '../../components';
import { User, UserStyle } from '../../models';
import './QuadrantGrid.css';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { UserStore, FilterStore } from '../../stores';
import './BadgeOverlayFix.css';
import { PVAPage } from '../layout/PVAPage';

export class SecondaryScaleData {
    public label: string;
    public valueX: number;
    public valueY: number;
    public pos: any;
    public user: User;
    public additionalClass: string;
}

export class SecondaryScaleCategory {
    public label: string;
}

interface SecondaryScaleProps {
    data: SecondaryScaleData[];
    one: SecondaryScaleCategory;
    two: SecondaryScaleCategory;
    UserStore?: UserStore;
    FilterStore?: FilterStore;
    listView: boolean;
    loading: boolean;
}

interface SecondaryScaleState {
    data: SecondaryScaleData[];
}

@inject('UserStore', 'FilterStore') @observer
export class SecondaryScale extends React.Component<SecondaryScaleProps, SecondaryScaleState> {
    private svgContainer: any;
    private quadrantGridContainer: any;

    constructor(props: SecondaryScaleProps) {
        super(props);

        this.state = {
            data: []
        };
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    componentDidMount() {
        this.buildInclinationChart();
        this.updateInclinationChart();
    }

    componentWillReceiveProps(nextProps: SecondaryScaleProps) {
        this.setState(
            {data: nextProps.data},
            this.updateInclinationChart
        );
    }

    buildInclinationChart() {
        const element = this.quadrantGridContainer; // ReactDom.findDOMNode(this);

        if (!element) {
            return;
        }

        this.svgContainer = d3.select(element).append('svg')
            .attr('width', element.clientWidth)
            .attr('height', element.clientHeight);

        // var borderSize: number = 18;
        var midMark = element.clientWidth * 0.5;
        var middleSize = element.clientWidth * 0.1;
        var middleSizeWithPadding = middleSize * 0.6;
        var middleSizePadding = middleSize - middleSizeWithPadding;
        // var halfMiddle = (middleSize * 0.9) * 0.5;

        var quadrantBG = 'rgba(0, 34, 62, 0.15)';

        // more pronounced section background
        const backgroundGroup = this.svgContainer.append('g');
        var quadrantOne = backgroundGroup.append('g');
        var quadrantSizeTotal = element.clientWidth - middleSizeWithPadding - middleSizeWithPadding / 2.0;
        var quadrantPadding = quadrantSizeTotal * 0.01;
        var quadrantSizeTotalPadded = quadrantSizeTotal - quadrantPadding;

        quadrantOne.append('rect')
            .attr('x', middleSizeWithPadding + middleSizeWithPadding / 2.0)
            .attr('y', 0)
            .attr('width', quadrantSizeTotalPadded / 2)
            .attr('height', quadrantSizeTotalPadded / 2)
            .attr('fill', quadrantBG);

        quadrantOne.append('rect')
            .attr('x', middleSizeWithPadding + middleSizeWithPadding / 2.0 + (quadrantSizeTotal / 2.0) + quadrantPadding / 2.0)
            .attr('y', 0)
            .attr('width', quadrantSizeTotalPadded / 2)
            .attr('height', quadrantSizeTotalPadded / 2)
            .attr('fill', quadrantBG);

        quadrantOne.append('rect')
            .attr('x', middleSizeWithPadding + middleSizeWithPadding / 2.0)
            .attr('y', (quadrantSizeTotal / 2.0) + quadrantPadding / 2.0)
            .attr('width', quadrantSizeTotalPadded / 2)
            .attr('height', quadrantSizeTotalPadded / 2)
            .attr('fill', quadrantBG);

        quadrantOne.append('rect')
            .attr('x', middleSizeWithPadding + middleSizeWithPadding / 2.0 + (quadrantSizeTotal / 2.0) + quadrantPadding / 2.0)
            .attr('y', (quadrantSizeTotal / 2.0) + quadrantPadding / 2.0)
            .attr('width', quadrantSizeTotalPadded / 2)
            .attr('height', quadrantSizeTotalPadded / 2)
            .attr('fill', quadrantBG);

        // Arrows

        // left
        backgroundGroup.append('rect')
            .attr('x', 0)
            .attr('y', middleSizeWithPadding * 0.5)
            .attr('width', middleSizeWithPadding)
            .attr('height', element.clientHeight - middleSizeWithPadding - middleSizeWithPadding)
            .attr('fill', 'rgba(22, 61, 90, 1.0)');

        // bottom
        backgroundGroup.append('rect')
            .attr('x', middleSizeWithPadding + middleSizeWithPadding / 2.0)
            .attr('y', element.clientHeight - middleSizeWithPadding)
            .attr('width', element.clientWidth - middleSizeWithPadding - middleSizeWithPadding)
            .attr('height', middleSizeWithPadding)
            .attr('fill', 'rgba(22, 61, 90, 1.0)');

        var halfSize = middleSizeWithPadding / 2.0;
        var lengthOfRot = Math.sqrt(halfSize * halfSize + halfSize * halfSize); // a^2 + b^2 = c^2

        var arrowX = midMark;
        var arrowY = midMark - (middleSize * 0.5) - 1 + (middleSizePadding * 0.4);
        
        // left arrow
        arrowX = (middleSizeWithPadding / 2.0);
        arrowY = (middleSizeWithPadding / 2.0);
        this.svgContainer.append('rect')
            .attr('width', lengthOfRot)
            .attr('height', lengthOfRot)
            .attr('transform', 'rotate(45, ' + arrowX + ', ' + arrowY + ')')
            .attr('x', arrowX - lengthOfRot * 0.5)
            .attr('y', arrowY - lengthOfRot * 0.5)
            .attr('fill', 'rgba(22, 61, 90, 1.0)');
        
        // bottom arrow
        arrowY = element.clientHeight - (middleSizeWithPadding / 2.0);
        arrowX = element.clientWidth - (middleSizeWithPadding / 2.0);
        this.svgContainer.append('rect')
            .attr('width', lengthOfRot)
            .attr('height', lengthOfRot)
            .attr('transform', 'rotate(45, ' + arrowX + ', ' + arrowY + ')')
            .attr('x', arrowX - lengthOfRot * 0.5)
            .attr('y', arrowY - lengthOfRot * 0.5)
            .attr('fill', 'rgba(22, 61, 90, 1.0)');
    
        {
            var valuesGuided = this.svgContainer.append('text').text(this.props.two.label)
                .attr('font-size', '150%')
                .attr('font-family', 'Open Sans')
                .attr('font-weight', 'bold')
                .attr('text-align', 'right')
                .attr('text-transform', 'uppercase')
                .attr('fill', '#899dac')
                .attr('text-anchor', 'middle');

            var valuesGuidedNode = valuesGuided.node();
            var valuesGuidedNodeBounds = valuesGuidedNode.getBBox();
            
            var valuesGuidedTextX = (valuesGuidedNodeBounds.height / 1.25);
            var valuesGuidedTextY = valuesGuidedNodeBounds.width / 2.0 + (middleSizeWithPadding / 2.0) + 15;
            valuesGuided
                .attr('x', valuesGuidedTextX)
                .attr('y', valuesGuidedTextY)
                .attr('transform', 'rotate(270, ' + valuesGuidedTextX + ', ' + valuesGuidedTextY + ')');
        }
        {
            var concrete = this.svgContainer.append('text').text(this.props.one.label)
                .attr('font-size', '150%')
                .attr('font-family', 'Open Sans')
                .attr('font-weight', 'bold')
                .attr('text-align', 'right')
                .attr('text-transform', 'uppercase')
                .attr('fill', '#899dac')
                .attr('text-anchor', 'middle');

            var concreteNode = concrete.node();
            var concreteNodeBounds = concreteNode.getBBox();
            
            var concreteTextX = element.clientWidth - (concreteNodeBounds.width / 2.0) - middleSizeWithPadding;
            var concreteTextY = element.clientHeight - (concreteNodeBounds.height / 3.0);
            concrete
                .attr('x', concreteTextX)
                .attr('y', concreteTextY);
        }

        // this.svgContainer.append('svg:image')
        //     .attr('xlink:href', 'images/grid_basic_bg.png');
        
        this.state.data.map((d: SecondaryScaleData) => {
            d.pos = this.addUser(quadrantOne, d, element.clientWidth - middleSizeWithPadding - middleSizeWithPadding / 2.0, element.clientHeight - middleSizeWithPadding - middleSizeWithPadding / 2.0, middleSizeWithPadding + middleSizeWithPadding / 2.0, element.clientHeight - middleSizeWithPadding - middleSizeWithPadding / 2.0);
        });

        this.setState(
            {
                data: this.state.data
            }
        );
     
    }

    addUser(svgContainer: any, data: SecondaryScaleData, width: number, height: number, x0: number, y0: number) {            
        
        var x: number = width / 2.0;
        var y: number = height / 2.0;

        var xPerc = data.valueX / 100.0;
        var yPerc = data.valueY / 100.0;

        var magicX = width; // 3.569;
        var magicY = height; // 2.32;

        var dotSize = 10;

        x = x0 + Math.min(width - dotSize, Math.max(0 + dotSize, magicX * xPerc));
        y = y0 - Math.min(height - dotSize, Math.max(0 + dotSize, magicY * yPerc));

        // x = Math.max(292, 287 + Math.min(214, 3.569 * (data.value - 35) - 6));
        // y = Math.min(224, Math.max(23, 2.32 * (100 - data.accomadate) + 6));

        this.addUserAt(svgContainer, data.label, x, y);
        return { x: x, y: y};
    }

    addUserAt(svgContainer: any, label: string, x: number, y: number) {
        // const userGroup = svgContainer.append('g');
        
        // userGroup.append('circle')
        //     .attr('cx', x)
        //     .attr('cy', y)
        //     .attr('r', 15)
        //     .attr('fill', 'rgba(0, 0, 0, 1.0)');
        
        // userGroup
        //     .append('text')
        //     .text(label)
        //     .attr('x', x)
        //     .attr('y', y + 4)
        //     .attr('font-size', '12')
        //     .attr('font-family', 'OpenSans')
        //     .attr('fill', 'white')
        //     .attr('text-anchor', 'middle');
    }

    updateInclinationChart() {
        this.svgContainer.remove();
        this.buildInclinationChart();
    }

    render() {
        // var q1c = this.props.data.filter((d: QuadrantGridData) => { return d.quadrant === 0; }).length;
        // var q2c = this.props.data.filter((d: QuadrantGridData) => { return d.quadrant === 1; }).length;
        // var q3c = this.props.data.filter((d: QuadrantGridData) => { return d.quadrant === 2; }).length;
        // var q4c = this.props.data.filter((d: QuadrantGridData) => { return d.quadrant === 3; }).length;
        // var q1 = 100.0 * (q1c / this.props.data.length);
        // var q2 = 100.0 * (q2c / this.props.data.length);
        // var q3 = 100.0 * (q3c / this.props.data.length);
        // var q4 = 100.0 * (q4c / this.props.data.length);
        // if (isNaN(q1)) { q1 = 0; }
        // if (isNaN(q2)) { q2 = 0; }
        // if (isNaN(q3)) { q3 = 0; }
        // if (isNaN(q4)) { q4 = 0; }

        // {this.props.two.label}

        if (this.props.listView) {
            return (
                <div>
                    <table className="table table-striped">
                        <tbody>
                            <tr>
                                <td>Name</td>
                                <td>{this.props.one.label}</td>
                                <td>{this.props.two.label}</td>
                            </tr>
                            {this.state.data.map((d: SecondaryScaleData, ind: number) => {
                                return <tr key={`sec-${ind}`}>
                                    <td>{d.user && d.user.firstName} {d.user && d.user.lastName}</td>
                                    <td>{Math.round(d.valueX)}</td>
                                    <td>{Math.round(d.valueY)}</td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                    { !this.props.loading && <PVAPage.Footer /> }
                </div>
            );
        } else {
            return (
                <>
                    <div className="flex-box">
                        <div>
                            <div className="quadrant-grid-bg">
                                <div className="quadrant-grid-container secondary-scale" ref={(e) => this.quadrantGridContainer = e}>
                                    <div className="quadrant-grid" />
                                    {
                                        this.state.data.map((d: SecondaryScaleData, ind: number) => {
                                            if (!d.pos) {
                                                return <div key={`user-${ind}`} />;
                                            }
                                            const styleName = this.getStyleName(d.user);
                                            const styleColor = this.getStyleColor(styleName);
                                            const initials = (d.user.firstName[0] || '') + (d.user.lastName[0] || '');
                                            return <div key={`person-${ind}`} className={`quadrant-person ${d.additionalClass}`} style={{'top': d.pos.y, 'left': d.pos.x, '--badge-color': styleColor} as any}>
                                                <div className="person">
                                                    {initials}
                                                    <div className="inner-content pva-badge-small person-popup">
                                                        <div className="popup-offset">
                                                            <div className="inner-content-bg">
                                                                <div className="text">
                                                                    <div className={"name " + `style-${styleName.toLowerCase()}`}>{d.user && d.user.firstName} {d.user && d.user.lastName} {d.user.userStyles && d.user.userStyles.length > 0 && d.user.userStyles[0].overridden && '*'}</div>
                                                                    <div>{this.props.one.label}: {Math.round(d.valueX)}</div>
                                                                    <div>{this.props.two.label}: {Math.round(d.valueY)}</div>
                                                                </div>
                                                                <div className="badge-container">
                                                                    {this.PVABadge(d.user, ind)}
                                                                </div>
                                                            </div>
                                                            <div className="triangle" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>;
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="team-grid-data-list-wrapper">
                            <div>
                                <label>Users</label>
                                <ul className="user-list">
                                    {
                                        this.state.data
                                            .filter(x => x.user)
                                            .sort(this.userSort)
                                            .map((secondaryScaleData: SecondaryScaleData, index: number) => {
                                                const styleName = this.getStyleName(secondaryScaleData.user);
                                                return <li key={`user-${secondaryScaleData.user.id}`} className="person pva-badge-small" onMouseEnter={() => this.addHoverClass(secondaryScaleData.user.id)} onMouseLeave={() => this.removeHoverClass(secondaryScaleData.user.id)}>
                                                    <span className="text">{secondaryScaleData.user.lastName}, {secondaryScaleData.user.firstName}</span>
                                                    {this.PVABadge(secondaryScaleData.user, index)}
                                                </li>;
                                            })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    { !this.props.loading && <PVAPage.Footer /> }
                </>
            );
        }
    }

    addHoverClass(userId: number) {
        let { data } = this.state;
        let dataIndex = data.findIndex(x => {
            return x.user.id === userId;
        });

        if (dataIndex >= 0) {
            // first remove pull-to-front from everyone
            data.forEach(x => x.additionalClass = '');

            // then set the new classes
            data[dataIndex].additionalClass = 'pull-to-front hovered-user';
            this.setState({data: data});
        }
    }

    removeHoverClass(userId: number) {
        let { data } = this.state;
        let dataIndex = data.findIndex(x => {
            return x.user.id === userId;
        });

        if (dataIndex >= 0) {
            data[dataIndex].additionalClass = '';
            this.setState({data: data});
        }
    }

    userSort(a: SecondaryScaleData, b: SecondaryScaleData) {
        if (a.user && b.user) {
            if (a.user.lastName > b.user.lastName) {
                return 1;
            } else if (a.user.lastName < b.user.lastName) {
                return -1;
            }
            if (a.user.firstName > b.user.firstName) {
                return 1;
            } else if (a.user.firstName < b.user.firstName) {
                return -1;
            }
        }

        return 0;
    }

    private getStyleName(user: User): string {
        if (!user || !user.userStyles) {
            return '';
        }

        var surveyVersionId = this.surveyVersion ? this.surveyVersion.id : 0;
        var userStyle = user.userStyles.find((us: UserStyle) => {
            return us.style.surveyVersionID === surveyVersionId;
        });

        if (userStyle) {
            return userStyle.style.name;
        }

        if (user.userStyles.length > 0) {
            return user.userStyles[0].style.name;
        }

        return '';
    }

    private getStyleColor(styleName: string): string {
        if (!styleName) {
            return 'var(--grey)';
        }
        return `var(--pva-${styleName.toLowerCase()})`;
    }

    private PVABadge(user: User, index: number) {
        if (user === undefined) {
            return <PVABadge key={`pvabadge-${index}`} style={''} badge={''} />;
        }
        if (!this.survey || !user.userStyles || !this.surveyVersion) {
            return <PVABadge key={`pvabadge-${index}`} style={''} badge={''} />;
        }

        var surveyVersionId = this.surveyVersion.id;
        var userStyle = user.userStyles.find((us: UserStyle) => {
            return us.style.surveyVersionID === surveyVersionId;
        });

        if (userStyle) {
            return <PVABadge key={`pvabadge-${index}`} style={userStyle.style.name} badge={userStyle.style.name[0]} />;
        }

        if (!userStyle && user.userStyles.length > 0) {
            return <PVABadge key={`pvabadge-${index}`} style={user.userStyles[0].style.name} badge={user.userStyles[0].style.name[0]} />;
        }

        return <PVABadge key={`pvabadge-${index}`} style={''} badge={''} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/charts/SecondaryScale.tsx